import { MerchantStructure } from '@nemuru-eng/js-api-client';
import { useEffect, useState } from 'react';

import { APPLICATION_TYPE_MENU_ITEMS } from '@/components/shared/components/ApplicationList/ApplicationTypeSelect/constants/applicationTypeMenuItems';
import { MenuItemType } from '@/components/shared/components/ApplicationList/ApplicationTypeSelect/types/MenuItemType';
import { ApplicationType } from '@/config/types';
import MerchantStructureEntity from '@/entities/MerchantStructureEntity';
import { useGetMerchantStructureById } from '@/hooks/requests/merchant/useGetMerchantStructureById';

interface UseApplicationType {
  merchantId: string;
  channelId?: string;
  agentId?: string;
}

export const useApplicationType = ({ merchantId, channelId, agentId }: UseApplicationType) => {
  const [selectedApplicationType, setSelectedApplicationType] = useState<ApplicationType | undefined>();
  const [menuItems, setMenuItems] = useState<MenuItemType[]>([]);

  const { merchantStructure } = useGetMerchantStructureById(merchantId);

  useEffect(() => {
    if (merchantStructure) setMenuItemsByMerchantStructure(merchantStructure);
  }, [merchantStructure]);

  const setMenuItemsByMerchantStructure = (merchantStructure: MerchantStructure): void => {
    const allowedProducts = MerchantStructureEntity.create({
      merchantStructure,
      channelId,
      agentId,
    }).getAllowedProducts();

    const filteredMenuItems = getMenuItemsByApplicationType(allowedProducts);

    if (filteredMenuItems.length) {
      setSelectedApplicationType(filteredMenuItems[0].value);
      setMenuItems(filteredMenuItems);
    }
  };

  const getMenuItemsByApplicationType = (applicationTypes: ApplicationType[]): MenuItemType[] => {
    const menuItems: MenuItemType[] = [];

    applicationTypes.forEach((applicationType) => {
      const menuItem = APPLICATION_TYPE_MENU_ITEMS.find((menuItem) => menuItem.value === applicationType);
      if (menuItem) {
        menuItems.push(menuItem);
      }
    });

    return menuItems.sort((a, b) => APPLICATION_TYPE_MENU_ITEMS.indexOf(a) - APPLICATION_TYPE_MENU_ITEMS.indexOf(b));
  };

  return {
    selectedApplicationType,
    setSelectedApplicationType,
    menuItems,
  };
};
